import React from "react";
import Image1920x156 from "../img/thumb/photo-1920x156--2.jpg";
import IconQuote from "../img/icons/icon-quotes.svg";
import IconGoal from "../img/icons/icon-goal.svg";
import IconSecurity from "../img/icons/icon-security.svg";
import IconWorld from "../img/icons/icon-world.svg";
import IconDevelopment from "../img/icons/icon-development.svg";
import {Config} from "../Config";

export default function Mission(prop) {

    let [data, setData] = React.useState(null);

    React.useEffect(() => {

        (async function() {
            try {
                const resView = await getMission();

                if(prop !== null && prop.lang === 'en') {
                    resView.title = resView.title_en;
                    resView.quote_en = resView.quote;
                    resView.mission1 = resView.mission1_en;
                    resView.mission2 = resView.mission2_en;
                    resView.mission3 = resView.mission3_en;
                    resView.mission4 = resView.mission4_en;
                }

                setData(resView);
            } catch (e) {
                //
            }
        })();
    }, []);

    async function getMission() {
        const response = await fetch(Config.apiUrl +'mission/view', {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                id: 1
            })
        });

        if(response.ok) {
            return response.json();
        }
        else {
            return response.json().then(err => Promise.reject(err));
        }
    }

    return (
        <>
            <div className="section section-banner small">
                <img src={Image1920x156} alt="" />
                <div className="container">
                    <p data-aos="fade-in"><a href={prop.lang === 'en' ? '/en':'/'}>{prop.lang === 'en' ? 'Home':'หน้าแรก'}</a> / {prop.lang === 'en' ? 'About Us':'เกี่ยวกับ ศชวซ.'} / {prop.lang === 'en' ? 'Vision and Mission':'วิสัยทัศน์ และพันธกิจ'}</p>
                    <h1 className="h2 textrow">
                        <span data-aos="fade-in">{prop.lang === 'en' ? 'Vision and Mission':'วิสัยทัศน์ และพันธกิจ'}</span>
                    </h1>
                </div>
            </div>

            <div className="section bg-light" style={{"--bg":"#F6F8FB"}}>
                <div className="container py-2">
                    <div className="boxed" style={{"--width":"1140px"}}>
                        <div className="hgroup mb-0 text-center w-icon-quotes">
                            <img className="icons svg-js left" src={IconQuote} alt="" />
                            <h2 className="text-primary">{prop.lang === 'en' ? data?.quote_en:data?.quote}</h2>
                            <img className="icons svg-js right" src={IconQuote} alt="" />
                        </div>
                    </div>
                </div>
            </div>

            <div className="section bg-light" style={{"--bg":"#EAF0FF"}}>
                <div className="container">
                    <h2 className="title-line-left fs-28 textrow mt-2">
                        <span data-aos="fade-right">{prop.lang === 'en' ? data?.title_en:data?.title}</span>
                    </h2>

                    <div className={"row g-3 pt-md-3 pt-3" + (data?.mission1 || data?.mission2 || data?.mission3 || data?.mission4 ? '':' d-none')}>
                        <div className={"col-12" + (data?.mission1 ? '':' d-none')}>
                            <div className="card-mission rows" data-aos="fade-in">
                                <div className="card-icon">
                                    <img className="icons" src={IconGoal} alt="" />
                                </div>
                                <div className="card-body">
                                    <h3 className="m-0">{data?.mission1}</h3>
                                </div>
                            </div>
                        </div>

                        <div className={"col-12" + (data?.mission2 ? '':' d-none')}>
                            <div className="card-mission rows" data-aos="fade-in">
                                <div className="card-icon">
                                    <img className="icons" src={IconSecurity} alt="" />
                                </div>
                                <div className="card-body">
                                    <h3 className="m-0">{data?.mission2}</h3>
                                </div>
                            </div>
                        </div>

                        <div className={"col-12" + (data?.mission3 ? '':' d-none')}>
                            <div className="card-mission rows" data-aos="fade-in">
                                <div className="card-icon">
                                    <img className="icons" src={IconWorld} alt="" />
                                </div>
                                <div className="card-body">
                                    <h3 className="m-0">{data?.mission3}</h3>
                                </div>
                            </div>
                        </div>

                        <div className={"col-12" + (data?.mission4 ? '':' d-none')}>
                            <div className="card-mission rows" data-aos="fade-in">
                                <div className="card-icon">
                                    <img className="icons" src={IconDevelopment} alt="" />
                                </div>
                                <div className="card-body">
                                    <h3 className="m-0">{data?.mission4}</h3>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="p-3"></div>

                </div>
            </div>
        </>
    );
} 